module.exports = __webpack_public_path__ + "static/img/cn_nanhai.26577e77.jpg";